module.exports = __webpack_public_path__ + "static/img/screen-4-en.45fab49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/how-it-works/screen-4-en.png
// module id = J0ho
// module chunks = 0